import { ShopifyShopSystemStrategy } from "./ShopifyShopSystemStrategy";

export class ThisPlaceShopSystemStrategy extends ShopifyShopSystemStrategy {
  registerEventHandlers(): void {
    const timeout = setTimeout(() => {
      const element = document.querySelector(
        ".order-summary-toggle__text",
      ) as HTMLElement;
      if (element) {
        element.click();
        clearTimeout(timeout);
      }
    }, 100);

    if (!document.URL.includes("checkout")) {
      setTimeout(() => {
        this.toggleOffset(false, false);
      }, 500);
    }
  }

  async refreshCart(): Promise<void> {
    window.location.reload();
  }
}
